/**
 * TeamSystem Impact - User DMA Assignments Hook
 *
 * Verifica se l'utente corrente ha IRO assegnati come stakeholder nella DMA.
 * Usato da AppSidebar e DMAPage per mostrare/restringere l'accesso ai contributori.
 * Se la fetch fallisce, ritorna { hasDmaAssessments: false } — non crasha.
 */

import { useState, useEffect } from 'react';
import { stakeholderAssessmentApi } from '../api';
import { useWorkingYear } from '../../../store/workingYearStore';

export interface UserDmaAssignments {
  hasDmaAssessments: boolean;
  loading: boolean;
}

export function useUserDmaAssignments(): UserDmaAssignments {
  const [hasDmaAssessments, setHasDmaAssessments] = useState(false);
  const [loading, setLoading] = useState(true);
  // Le assegnazioni DMA sono per-anno: l'icona deve riflettere SOLO l'anno di
  // lavoro corrente, altrimenti un assessment di un altro anno la fa comparire
  // in tutti gli anni.
  const { year } = useWorkingYear();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    stakeholderAssessmentApi
      .getMyAssignedIROs(false, year)
      .then((result) => {
        if (!cancelled) {
          setHasDmaAssessments(result.assigned.length > 0);
        }
      })
      .catch(() => {
        // Non crashare — nessun assessment assegnato
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [year]);

  return { hasDmaAssessments, loading };
}
